<div class="container-fluid py-5 iff-detail-header-cell-text">
  <div>
    <app-iff-detail-header [selectedIFFShipmentSummary$]="selectedIFFShipmentSummary$"
    (exportClicked)="onExport()"></app-iff-detail-header>
  </div>
  <ag-grid-angular
    class="ag-theme-alpine"
    [gridOptions]="hhgIFFShipmentDetailGridOptions"
    [rowData]="hhgIFFShipmentDetailResults$ | async"
  >
  </ag-grid-angular>
</div>
